/* eslint-disable camelcase */
import React, { useMemo, useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { FormattedDate } from 'react-intl'

// import BannerAina from '@/components/banner/aina'
import Loading from '@/components/common/loading'
import Avatar from '../../components/app/avatar'
import { Placeholder } from '../../components/app/media'
import Waveform from '../../components/app/waveform'
import { Button } from '../../components/common/button'
import Spinner from '../../components/common/spinner'
import PlayBtn from '../media/sound/play'

import Latest from './latest'
import styles from './explore.module.scss'
import { MediaIndex, SoundIndex, UserIndex } from '@/interfaces/algolia'

interface Props {
  featuredSound: SoundIndex[]
  featuredUser: UserIndex[]
  mediaList: MediaIndex[]
}

const HomePage = ({ featuredSound, featuredUser, mediaList }: Props) => {
  const [ isMore, setMore ] = useState(true)
  const [ page, setPage ] = useState(1)
  const [ isLoading, setLoading ] = useState(false)

  const [
    featuredFirst,
    featuredSecond,
    featuredList1,
    // featuredList2,
  ] = useMemo(() => {
    let cfeaturedFirst: SoundIndex
    let cfeaturedSecond: SoundIndex
    const cfeaturedList1: SoundIndex[] = []
    const cfeaturedList2: SoundIndex[] = []
    featuredSound.forEach((media, index) => {
      if (index === 0) {
        cfeaturedFirst = media
        return
      }
      if (index === 1) {
        cfeaturedSecond = media
        return
      }
      if (index <= 4) {
        cfeaturedList1.push(media)
        return
      }
      if (index <= 8) {
        cfeaturedList2.push(media)
      }
    })
    return [ cfeaturedFirst, cfeaturedSecond, cfeaturedList1, cfeaturedList2 ]
  }, [ featuredSound ])

  return (
    <>
      <main className="container my-5">
        {/* <BannerAina /> */}
        <h2 className="tx-oswald tx-w300 mb-5">Featured on SOUND ON LIVE</h2>
        {!featuredSound ? (
          <Loading />
        ) : (
          <>
            {featuredFirst && (
              <div className={`${styles.featureFirst} row mb-5`}>
                <div className="col-md-8 mb-md-0 mb-4">
                  <div className="ps-relative">
                    <Link href={`/sound/${featuredFirst?.id}/${featuredFirst?.slug}`} className="d-block">
                      <Image
                        src={featuredFirst?.coverart_crop_url || '/static/images/cover.png'}
                        alt={featuredFirst?.title}
                        className={`shadow-coverart ${styles.img}`}
                        width={780}
                        height={320}
                      />
                    </Link>
                    <PlayBtn
                      size="2rem"
                      className={styles.playOnCover}
                      sound={{
                        ...featuredFirst,
                        id: featuredFirst?.id,
                        user: { name: featuredFirst?.user?.username },
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-4 pl-md-4">
                  <h3 className="tx-20 tx-md-32 tx-w700 tx-ellipsis2 mb-3">
                    <Link
                      href={`/sound/${featuredFirst?.id}/${featuredFirst?.slug}`}
                      className="alt"
                    >
                      {featuredFirst?.title}
                    </Link>
                  </h3>
                  <Link
                    href={`/user/${featuredFirst?.user?.username}`}
                    className="nohover"
                  >
                    <div className="d-flex align-items-center">
                      <Avatar
                        src={featuredFirst?.user?.user_image}
                        width="24"
                        alt=""
                      />
                      <span className="tx-12 ml-1">
                        {featuredFirst?.user?.username}
                      </span>
                      <span className="dot" />
                      <span className="tx-14 tx-g600">
                        <FormattedDate
                          value={featuredFirst?.released_at}
                          year="numeric"
                          month="short"
                          day="2-digit"
                        />
                      </span>
                    </div>
                  </Link>
                  <p className="tx-16 tx-ellipsis3 my-3">
                    {featuredFirst?.description}
                  </p>
                  <Waveform
                    id={featuredFirst?.id}
                    duration={featuredFirst?.metadata?.duration}
                    src={featuredFirst?.waveform_url}
                    static={featuredFirst?.limit?.on}
                  />
                </div>
              </div>
            )}
            {featuredSecond && (
              <div className={`${styles.featureSecond} row mb-5`}>
                <div className={`${styles.order2} col-md-8 mb-md-0 mb-4`}>
                  <div className="ps-relative">
                    <Link href={`/sound/${featuredSecond.id}/${featuredSecond.slug}`} className="d-block">
                      <Image
                        src={featuredSecond.coverart_crop_url || '/static/images/cover.png'}
                        alt={featuredSecond.title}
                        className={`shadow-coverart ${styles.img}`}
                        width={780}
                        height={320}
                      />
                    </Link>
                    <PlayBtn
                      size="2rem"
                      className={styles.playOnCover}
                      sound={{
                        ...featuredSecond,
                        id: featuredSecond.id,
                        user: { name: featuredSecond.user?.username },
                      }}
                    />
                  </div>
                </div>
                <div className={`${styles.order1} col-md-4 pl-4`}>
                  <h3 className="tx-20 tx-md-32 tx-w700 tx-ellipsis2 mb-3">
                    <Link
                      href={`/sound/${featuredSecond.id}/${featuredSecond.slug}`}
                      className="alt"
                    >
                      {featuredSecond.title}
                    </Link>
                  </h3>
                  <Link
                    href={`/user/${featuredSecond.user?.username}`}
                    className="nohover"
                  >
                    <div className="d-flex align-items-center">
                      <Avatar
                        src={featuredSecond.user?.user_image}
                        width="24"
                        alt=""
                      />
                      <span className="tx-12 ml-1">
                        {featuredSecond.user?.username}
                      </span>
                      <span className="dot" />
                      <span className="tx-14 tx-g600">
                        <FormattedDate
                          value={featuredSecond.released_at}
                          year="numeric"
                          month="short"
                          day="2-digit"
                        />
                      </span>
                    </div>
                  </Link>
                  <p className="tx-ellipsis3 my-3">
                    {featuredSecond.description}
                  </p>
                  <div className="mt-3">
                    <Waveform
                      id={featuredSecond.id}
                      duration={featuredSecond.metadata?.duration}
                      src={featuredSecond.waveform_url}
                      static={featuredSecond.limit?.on}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className={`row ${styles.featuredList}`}>
              {
                featuredList1.length > 0 && featuredList1.map((media) => (
                  <div key={`feature-list-${media.id}`} className="col-md mb-5">
                    <div className={`row ${styles.featuredListSub}`}>
                      <div className="col-6 col-md-12">
                        <div className="ps-relative mb-md-4">
                          <Link href={`/sound/${media.id}/${media.slug}`} className="d-block">
                            <Image
                              src={media.coverart_crop_url || '/static/images/cover.png'}
                              alt={media.title}
                              className={`shadow-coverart ${styles.img}`}
                              width={320}
                              height={160}
                            />
                          </Link>
                          <PlayBtn
                            size="2rem"
                            className={styles.playOnCover}
                            sound={{
                              ...media,
                              id: media.id,
                              user: { name: media.user?.username },
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-6 col-md-12">
                        <h3 className="tx-20 tx-w700 tx-ellipsis2 mb-3">
                          <Link
                            href={`/sound/${media.id}/${media.slug}`}
                            className="alt"
                          >
                            {media.title}
                          </Link>
                        </h3>
                        <Link
                          href={`/user/${media.user?.username}`}
                          className="nohover"
                        >
                          <div className="d-flex align-items-center">
                            <Avatar
                              src={media.user?.user_image}
                              width="24"
                              alt=""
                            />
                            <span className="tx-12 ml-1">
                              {media.user?.username}
                            </span>
                            <span className="dot" />
                            <span className="tx-14 tx-g600">
                              <FormattedDate
                                value={media.released_at}
                                year="numeric"
                                month="short"
                                day="2-digit"
                              />
                            </span>
                          </div>
                        </Link>
                        <div className="mt-3">
                          <span className="tx-16 tx-ellipsis3">
                            {media.description}
                          </span>
                        </div>
                        <div className="mt-3">
                          <Waveform
                            id={media.id}
                            duration={media.metadata?.duration}
                            src={media.waveform_url}
                            static={media.limit?.on}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </>
        )}
        <div className={styles.pickups}>
          <div className={`${styles.pickupArtist} mb-4`}>
            <h2 className={`heading ${styles.innerHeader}`}>
              <span
                className={`text tx-20 tx-oswald ${styles.innerHeaderText}`}
              >
                Pickup Artists
              </span>
            </h2>
            {!featuredUser ? (
              <Loading />
            ) : (
              <div className={`row ${styles.smflex} ${styles.smScroll}`}>
                <div className={styles.nowrap}>
                  {featuredUser.length > 0 &&
                    featuredUser.map((user) => (
                      <div
                        className={`${styles.user} d-inline-block d-md-flex  pb-4`}
                        key={user.username}
                      >
                        <div className="flex0 mr-md-3">
                          <Link
                            href={`/user/${user.username}`}
                            className="nohover"
                          >
                            <Avatar
                              className={`${styles.avatar} mb-3`}
                              src={user.user_image}
                              alt={user.name}
                            />
                          </Link>
                        </div>
                        <div className="flex1">
                          <h3 className="tx-16 tx-w500 mb-2">
                            <Link
                              href={`/user/${user.username}`}
                              className="alt"
                            >
                              {user.name}
                            </Link>
                          </h3>
                          <p className="tx-14 tx-ellipsis3 tx-g800">
                            {user.shortBio}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
          <div className={`${styles.latestUploads}`}>
            <h2 className={`heading ${styles.innerHeader}`}>
              <span
                className={`text tx-20 tx-oswald ${styles.innerHeaderText}`}
              >
                Latest Uploads
              </span>
            </h2>
            {new Array(page).fill(0).map((_, i) => (
              <Latest
                latest={i === 0 && mediaList}
                page={i + 1}
                // eslint-disable-next-line react/no-array-index-key
                key={`latest-${i}`}
                noMore={() => setMore(false)}
                loaded={() => i + 1 === page && setLoading(false)}
              />
            ))}
            {isMore && (
              <div className="tx-center mb-5">
                {isLoading ? (
                  <>
                    <Spinner size="1.25rem" />
                    <span className="tx-oswald tx-w300 ml-2">Loading</span>
                  </>
                ) : (
                  <Button
                    className="lg"
                    onClick={() => {
                      setLoading(true)
                      setPage(page + 1)
                    }}
                  >
                    Load more
                  </Button>
                )}
              </div>
            )}
            {page <= 0 && (
              <>
                <Placeholder />
              </>
            )}
          </div>
        </div>
      </main>
    </>
  )
}

export default HomePage
